/** Finance console sub-navigation (§16.2: balanced ledger, provider reconciliation, refunds, payout maker/checker). */
import { NavLink } from 'react-router';

const LINKS = [
  { to: '/finance', label: 'Reconciliation', end: true },
  { to: '/finance/refunds', label: 'Refunds' },
  { to: '/finance/payouts', label: 'Payouts' },
  { to: '/finance/ledger', label: 'Ledger' },
];

export function FinanceNav() {
  return (
    <nav aria-label="Finance sections" className="wd-btn-group" style={{ marginBottom: 'var(--wd-space-4)' }}>
      {LINKS.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.end} className="wd-btn" data-variant="secondary">
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}

export const money = (m: { amountMinor: string; currency: string }, fmt: (a: string, c: string) => string) =>
  fmt(m.amountMinor, m.currency);
